import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { Link } from 'react-router-dom'
import JNJFooter from '../../features/jnj-footer/JNJFooter'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import { SectionHeader } from '../../features/section-components/SectionHeader'
import { LoadingIcon } from '../../features/section-components/LoadingIcon'
import {
  selectUserCallStatus,
} from '../../features/user/userSlice'
import styles from './EditLanguage.module.scss'

function EditLanguageMobile({
  t,
  languageSelectorComponent,
  isPageLoading
}) {
  const userCallStatus = useSelector(selectUserCallStatus)

  return (
    <MarginWrapper>
      <LoadingIcon isLoading={isPageLoading || userCallStatus === 'failed'}>
        <div className={styles['edit-language-mobile']}>
          <div className={styles['mobile-back-home-section']}>
            <Link
              to="/account"
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
              color="black"
            >
              <ArrowBackIosIcon
                className={styles['home-icon']}
                fontSize="inherit"
              />
              <div className={styles['home-text']}>{t('account-tab')}</div>
            </Link>
          </div>
          <div className={styles['edit-language-container-mobile']}>
            <SectionHeader text={t('label-pref-lang')} size="medium" />
            <span className={styles['secondary-text-mobile']}>{t('support-text-pref-lang')}</span>
            {languageSelectorComponent}
            <div className={styles['JNJ-footer']} style={{ alignSelf: 'center' }}>
              <JNJFooter />
            </div>
          </div>
        </div>
      </LoadingIcon>
    </MarginWrapper>
  )
}

EditLanguageMobile.propTypes = {
  t: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
  languageSelectorComponent: PropTypes.node.isRequired,
}

export default EditLanguageMobile
